import React, { useState } from 'react';

const RatingStars = ({ totalStars = 5, value } : any) => {
    const { selectedValue, onChange, className, fillColor, emptyColor, fontSize } = value;
    const [hover, setHover] = useState(0);

    const handleClick = (rate:any) => {
       
        if (onChange) onChange(rate);
    };
    

    const getStarIcon = (index:any) => {
        if (hover >= index) {
            return 'star';
        } else if (hover >= index - 0.5) {
            return 'star_half';
        } else if (selectedValue >= index) {
            return 'star';
        } else if (selectedValue >= index - 0.5) {
            return 'star_half';
        } else {
            return 'star_border';
        }
    };
   
    return (
        <div className={className}>
            {[...Array(totalStars)].map((_, i) => {
                const index = i + 1;


                const iconStyles = {
                    fontVariationSettings: `'FILL' ${getStarIcon(index) !== 'star_border' ? 1 : 0}`
                  };
                return (
                    <label key={index}>
                        <input
                            type="radio"
                            name="rating"
                            value={index}
                            onClick={() => handleClick(index)}
                            style={{ display: 'none' }}
                        />
                        <span
                            className={`material-symbols-outlined ${fontSize ? fontSize : 'text-4xl'}`}
                            onMouseEnter={() => onChange ? setHover(index) : null}
                            onMouseLeave={() => onChange ? setHover(0) : null}
                            style={{
                                ...iconStyles,
                                cursor: onChange ? 'pointer' : '',
                             
                                color: getStarIcon(index) !== 'star_border' ? fillColor : emptyColor,
                            }}
                        >
                            {getStarIcon(index)}
                        </span>
                    </label>
                );
            })}
        </div>
    );
};

export default RatingStars;